import classNames from 'classnames';
import noop from 'lodash/noop';
import useDarkMode from 'use-dark-mode';
import styles from './checkbox.module.scss';
import { sanitizeHtml } from '../../../helpers/sanitize';

type Props = {
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isChecked?: boolean;
  label?: string;
  checkmarkClassName?: string;
  labelClassName?: string;
  titleClassName?: string;
  subtitle?: string;
  id: string;
  style?: CSSStyleDeclaration;
  ariaDescribedBy?: string;
  reverseDirection?: boolean;
  isReadOnly?: boolean;
};

const CheckboxComp = (props: Props) => {
  const darkMode = useDarkMode(false, {
    element: document.documentElement,
  });
  return (
    <div
      className={classNames(
        styles.checkbox,
        props.reverseDirection && styles['checkbox--reversed'],
      )}
    >
      <span
        className={classNames(
          styles['checkbox__checkmark'],
          props.isChecked &&
            !props.isReadOnly &&
            styles[
              `checkbox__checkmark--checked${darkMode.value ? '-dark' : ''}`
            ],
          props.isChecked &&
            props.isReadOnly &&
            styles['checkbox__checkmark--checked-read-only'],
          props.checkmarkClassName && styles[props.checkmarkClassName],
        )}
      >
        <input
          type='checkbox'
          id={props.id}
          checked={props.isChecked}
          aria-describedby={props.ariaDescribedBy}
          onChange={props.handleChange || noop}
          tabIndex={props.isReadOnly ? -1 : 0}
          disabled={props.isReadOnly}
        />
      </span>
      <label
        htmlFor={props.id}
        className={classNames(
          styles['checkbox__label'],
          props.isChecked && styles['checkbox__label--checked'],
          !!props.label &&
            !!props.subtitle &&
            styles['checkbox__label--subtitle'],
          props.reverseDirection && styles['checkbox__label--reversed'],
          props.labelClassName && styles[props.labelClassName],
        )}
      >
        {!!props.label && (
          <span
            className={classNames(
              styles['checkbox__title'],
              props.titleClassName && styles[props.titleClassName],
            )}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(props.label || ''),
            }}
          />
        )}
        {!!props.subtitle && (
          <span className={styles['checkbox__subtitle']}>{props.subtitle}</span>
        )}
      </label>
    </div>
  );
};

CheckboxComp.displayName = 'CheckboxComp';

export default CheckboxComp;
